import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ISearchResult } from '../search/typings';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) { }

  getSearchResults(searchTerm: string): Observable<ISearchResult> {
    const params = new HttpParams().set("searchQuery", searchTerm);
    const headers = new HttpHeaders().set('no-spinner', 'true');
    return this.http.get<ISearchResult>(env.API.search_url, {params, headers});
  }
}
